import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { getSpecificRoleUser } from '@/util/paid-user-util';

@Component({
  computed: {},
  methods: { getSpecificRoleUser },
  components: {},
})
export default class OutOfActive extends Vue {
  @Prop(Boolean) readonly openModal;
  @Prop(Number) readonly featureIdx;
  numCount = 0;
  localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;
  plan = '';

  @Emit('no') no() {}

  get featureIndex() {
    return this.featureIdx;
  }

  mounted() {
    this.numCount = this.localStorageUser?.policyUsers?.find(item => item.featureIdx === this.featureIndex)?.total;
    if (getSpecificRoleUser() === 'Free') {
      this.plan = 'Pro';
    } else {
      this.plan = 'Ultra';
    }
  }

  routeToPricingPlan() {
    this.$router.push('/pricing-plan');
  }
}
